var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconChevronDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "nonzero",
  d: "M14.5 8.394L10 13 5.5 8.394a1.904 1.904 0 0 1 2.724 0L10 10.212l1.776-1.818a1.904 1.904 0 0 1 2.724 0z"
})));
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj48cGF0aCBmaWxsPSJjdXJyZW50Q29sb3IiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTE0LjUgOC4zOTRMMTAgMTMgNS41IDguMzk0YTEuOTA0IDEuOTA0IDAgMCAxIDIuNzI0IDBMMTAgMTAuMjEybDEuNzc2LTEuODE4YTEuOTA0IDEuOTA0IDAgMCAxIDIuNzI0IDB6Ii8+PC9zdmc+DQo=";
export { SvgIconChevronDown as ReactComponent };